import React from "react";
import StartCreatingHero from "./HeroSection/StartCreatingHero";
import ChooseImageSize from "./ChooseImageSize/ChooseImageSize";
const StartCreating = () => {
  return (
    <>
      <StartCreatingHero />
      <ChooseImageSize />
      
    </>
  );
};

export default StartCreating;
